import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';

const BSLADryCleaningLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/DWM_STCM/MapServer/4',
        visible: false,
        title: 'Drycleaning Solvent Cleanup (FDEP)',
        popupTemplate: {
            outFields: ['*'],
            title: 'Drycleaning Solvent Cleanup (FDEP)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');
                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Name" value={atts.NAME} />
                        <BSLAPopupItemComponent label="Program" value={atts.PROGRAM} />
                        <BSLAPopupItemComponent label="Site ID" value={atts.ERIC_ID} />
                        <BSLAPopupItemComponent label="District" value={atts.DISTRICT} />
                        <div className="mt-3 mb-1">
                            {atts.ADDRESS}
                            <br />
                            {atts.CITY}, FL
                            <br />
                            {atts.COUNTY} County
                        </div>
                        <p className="mb-1">
                            This layer depicts sites that have actively participated in the Dry Cleaning Solvent cleanup program. Improper disposal of solvents, such as pouring
                            chemical(s) down a drain into septic systems or directly into the ground can contaminate groundwater or air quality. Even 100 years after the initial
                            contamination, vapors from the solvents can be released from aged septic systems, migrate through soil and into buildings, causing air pollution.
                        </p>
                        <BSLAExternalLinkComponent href={atts.DOCUMENTS} />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLADryCleaningLayer;
